<template>
  <div id="UsersAdmin">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span v-if="role=='admin'">Administrators</span>
              <span v-if="role=='supervisor'">{{client.supervisorLabel}}s</span>
              <span v-if="role=='agent'">{{client.agentLabel}}s</span>
              <span v-if="role=='custom'">Custom users</span>
            </h1>
            <!-- <div class="page-header-subtitle" v-if="role != 'all'">{{role}}</div> -->
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <vue-good-table
                  :columns="columns"
                  :rows="users"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter',
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: 20,
                  }"
                  styleClass="vgt-table condensed myGoodTable"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'name'">
                      <router-link :to="{name: 'UserDetailsAdmin', params: {uuid: props.row.uuid}}">
                        <b>{{props.row.name}}</b>
                      </router-link>
                    </span>
                    <span v-if="props.column.field == 'email'">{{props.row.email}}</span>
                    <span v-if="props.column.field == 'phone'">{{props.row.phone}}</span>

                    <span v-if="props.column.field == 'createdAt'">{{props.row.createdAt| formatDateTime}}</span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>


<script>
import axios from "axios";

export default {
  name: "UsersAdmin",

  data() {
    return {
      users: [
        {
          role: { name: "" },
          categories: [{ name: "" }],
          subCategories: [{ name: "" }],
        },
      ],
      role: "",
    };
  },

  watch: {
    "$route.params.role": function (role) {
      this.loadUsers(role);
      this.role = role;
      window.scrollTo(0, 0);
    },
  },

  mounted() {
    let role = "agent";
    if (this.$route.params.role != undefined) {
      role = this.$route.params.role;
    }
    this.loadUsers(role);
    this.role = role;
  },

  methods: {
    loadUsers(role) {
      let loading = this.$loading.show();
      axios.get(`/admin/users?role=${role}`).then((res) => {
        if (res.data.status == "success") {
          this.users = res.data.users;
        }
        loading.hide();
      });
    },
  },

  computed: {
    columns() {
      /* let roleLable = "";
      if (this.role == "agent") {
        roleLable = this.client.topCategoryLabel;
      } else if (this.role == "supervisor") {
        roleLable = this.client.subCategoryLabel;
      } */
      let cols = [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "Phone",
          field: "phone",
        },

        {
          label: "Date/Time",
          field: "createdAt",
        },
      ];
      return cols;
    },

    client() {
      return this.$store.state.client;
    },
  },
};
</script>

